import * as CreateInvestorDeckTypes from 'src/actions/investor-deck/create/Types';
import { CreateInvestorDeckAction } from 'src/actions/investor-deck/create/CreateInvestorDeck.actions';

export interface CreateInvestorDeckState {
  loading: boolean;
  error: boolean;
  errorMessage: {};
}

const initialState: CreateInvestorDeckState = {
  loading: false,
  error: false,
  errorMessage: {}
};

export function CreateInvestorDeckReducer(state: CreateInvestorDeckState = initialState,
                                          action: CreateInvestorDeckAction): CreateInvestorDeckState {
  switch (action.type) {
    case CreateInvestorDeckTypes.CREATE_INVESTOR_DECK_ATTEMPT:
      return {...state, loading: true, error: false};
    case CreateInvestorDeckTypes.CREATE_INVESTOR_DECK_SUCCESS:
      return {...state, loading: false, error: false};
    case CreateInvestorDeckTypes.CREATE_INVESTOR_DECK_FAILURE:
      return {...state, loading: false, error: true, errorMessage: action.payload};
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/investor-deck/CreateInvestorDeckReducer.tsx